import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";

// context
import { UserContext } from "../../../Context/UserContextProvider";

// styles
import styles from "./MeetingsArchive.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";

// Re Useable Components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import MeetingsArchiveCard from "./MeetingsArchiveCard";
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import Dropdown from "react-bootstrap/Dropdown";
import Checkbox from "@mui/material/Checkbox";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";
import filterIcon from "../../../../assets/img/DashboardICons/FilterIcon.svg";
import arrowDown from "../../../../assets/img/DashboardICons/ArrowDown.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const MeetingsArchive = () => {
  const { userToken, permissions, userData } = useContext(UserContext);
  const history = useHistory();
  const [query, setQuery] = useState("");
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [cardInfo, setCardInfo] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [filterBtns, setFilterBtns] = useState({
    onGoing: true,
    heldOn: false,
    canceld: false,
  });
  const filterNumber = filterBtns.canceld === true ? "3" : filterBtns.heldOn === true ? "2" : filterBtns.onGoing === true && "1";

  useEffect(() => {
    const getData = async () => {
      const getFilterdData = await axios.get(
        permissions?.find(item => item === 15) === 15
          ? `Meeting?Status=${filterNumber}&PageId=${page.pageNumber}&Take=10`
          : `Meeting?UserId=${userData.id}&Status=${filterNumber}&PageId=${page.pageNumber}&Take=10`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getFilterdData.data.data.pageCount };
      });
      setCardInfo(getFilterdData.data.data.data);
      setIsLoading(false);
    };
    getData();
  }, [filterNumber, userToken, permissions, userData, page.pageNumber]);

  const search = data => {
    return data.filter(item => item.title.toLowerCase().includes(query));
  };

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <style type="text/css">
        {`
    .dropdown-toggle {
        width: 159px;
        height: 44px;
        background: #f9f9f9;
        border: 1px solid #e2e2e2;
        border-radius: 34px;
        margin-left: 0.75rem;
        color: #1D1D1D;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .dropdown-toggle:after,
    .btn-success:after {
        content: none;
    }
    
    .btn-success {
        background: #f9f9f9 !important;
        border: 1px solid #e2e2e2 !important;
        color: #1D1D1D !important;
        box-shadow: none !important;
    }
    
    .dropdown-toggle:hover {
        background: #f4f4f4;
        color: #1D1D1D;
        border-color: #e5e5e5;
        border: 1px solid #e2e2e2;
    }

    .dropdown-menu {
        width: 159px;
        background: #F9F9F9;
        border: 1px solid #E2E2E2;
        border-radius: 34px;
    }

    .dropdown-item {
        margin: .5rem 0;
        padding: .5rem .5rem .5rem 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #1D1D1D;
    }

    .dropdown-item:hover {
        background: #E7EAF4 !important;
        border-radius: 24px !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #1D1D1D;
    }
    `}
      </style>

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`mt-3 px-0 ${Dstyles.container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} query={query} setQuery={setQuery} />

                {/* head title */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div
                      className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                      dir="rtl"
                      // className={`w-100 d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3 ${styles.cards_container}`}
                    >
                      <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                        <div className="d-flex align-items-center justify-content-center">
                          <a href="#" onClick={history.goBack}>
                            <img className="ms-2" src={arrowIcon} alt="icon" />
                          </a>
                          <div className={Dstyles.text1}>آرشیو جلسات</div>
                        </div>

                        <div className={`d-flex align-items-center justify-content-between ${styles.filter_btns_left_container}`}>
                          <div className={`d-flex align-items-center justify-content-around ${styles.filter_btn_container}`}>
                            <Dropdown dir="rtl">
                              <Dropdown.Toggle variant="success" id="dropdown-basic">
                                <img className="me-1 ms-2" src={filterIcon} alt="icon" />
                                فیلتربندی
                                <img className="me-3" src={arrowDown} alt="icon" />
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item>
                                  <Checkbox
                                    checked={filterBtns.heldOn}
                                    onClick={handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                    size="small"
                                    name="heldOn"
                                  />
                                  برگزار شده
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <Checkbox
                                    checked={filterBtns.onGoing}
                                    onClick={handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                    size="small"
                                    name="onGoing"
                                  />
                                  در انتظار برگزاری
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <Checkbox
                                    checked={filterBtns.canceld}
                                    onClick={handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                    size="small"
                                    name="canceld"
                                  />
                                  لغو شده
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* head title */}

                {/* card */}
                <MeetingsArchiveCard cardData={search(cardInfo)} />
                {/* card */}

                <Stack
                  className={Dstyles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu meeting meetingArchive />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function handleChange(event) {
    if (event.target.name === "heldOn") {
      const name = "heldOn";
      setFilterBtns(prev => {
        return { ...prev, [name]: event.target.checked, onGoing: false, canceld: false };
      });
    } else if (event.target.name === "onGoing") {
      const name = "onGoing";
      setFilterBtns(prev => {
        return { ...prev, [name]: event.target.checked, heldOn: false, canceld: false };
      });
    } else if (event.target.name === "canceld") {
      const name = "canceld";
      setFilterBtns(prev => {
        return { ...prev, [name]: event.target.checked, onGoing: false, heldOn: false };
      });
    }
  }

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getApiData = await axios.get(
      permissions?.find(item => item === 15) === 15
        ? `Meeting?PageId=${value}&Status=${filterNumber}`
        : `Meeting?PageId=${value}&UserId=${userData.id}&Status=${filterNumber}`,
      {
        headers: { authorization: "Bearer " + userToken },
      }
    );
    setPage(prev => {
      return { ...prev, pageCount: getApiData.data.data.pageCount, pageNumber: value };
    });
    setCardInfo(getApiData.data.data.data);
    setIsLoading(false);
  }
};

export default MeetingsArchive;
